var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdmEditorOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edm-editor-open_svg__clip0_4855_56659)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#edm-editor-open_svg__filter0_d_4855_56659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 8l-11.302 2.511A6 6 0 008 16.37V47.63a6 6 0 004.698 5.858L24 56h1V8h-1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 8.5h-.445L12.807 11A5.5 5.5 0 008.5 16.369V47.63a5.5 5.5 0 004.307 5.37L24.055 55.5h.445v-47z",
    stroke: "#E1E3E8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.603 36.267a.562.562 0 00.928-.428v-7.678c0-.481-.563-.74-.928-.428l-4.48 3.84a.563.563 0 000 .854l4.48 3.84z",
    fill: "#8D92A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edm-editor-open_svg__clip0_4855_56659"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v64H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edm-editor-open_svg__filter0_d_4855_56659",
    x: -2,
    y: 2,
    width: 37,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.184314 0 0 0 0 0.32549 0 0 0 0 0.52549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4855_56659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4855_56659",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/edm-editor-open.4395d58c.svg";
export { SvgEdmEditorOpen as ReactComponent };